import {Button} from '@primer/react'

import styles from './SpaceDialogFooter.module.css'

interface SpaceDialogFooterProps {
  onSave: () => void
  onCancel: () => void
  isLoading?: boolean
  loadingAnnouncement?: string
  disabled?: boolean
}

/**
 * This component renders a standardized footer with two buttons:
 * - A Cancel button that triggers the onCancel callback
 * - A Save button that triggers the onSave callback and can show loading/disabled states
 */
export function SpaceDialogFooter({
  onSave,
  onCancel,
  isLoading = false,
  loadingAnnouncement = '',
  disabled = false,
}: SpaceDialogFooterProps) {
  return (
    <div className={styles.footerContainer}>
      <Button variant="default" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        variant="primary"
        loading={isLoading}
        loadingAnnouncement={loadingAnnouncement}
        onClick={onSave}
        disabled={disabled || isLoading}
      >
        Save
      </Button>
    </div>
  )
}

try{ SpaceDialogFooter.displayName ||= 'SpaceDialogFooter' } catch {}